<template>
    <div>
         <!--
    <table width='100%' class='table' v-if='data.length'>
      <tr>
        <th width='15%' class='colTitle'>{{ $t("Env") }}</th>
        <th width='15%' class='colTitle'>{{ $t("Client") }}</th>
        <th width='15%' class='colTitle'>{{ $t("Instrument") }}</th>
        <th width='10%' class='colTitle'>{{ $t("Order Side") }}</th>
        <th width='10%' class='colTitle'>{{ $t("Order Type") }}</th>
        <th width='15%' class='colTitle'>{{ $t("Price") }}</th>
        <th width='15%' class='colTitle'>{{ $t("Working Amt") }}</th>
      </tr>
      <tr v-for='(cli, index) in data' :key='index'  v-if='index < count' class='lu-click' @dblclick='getDetail(cli.accountName)'>
        <td width='15%' class='rowTitle'>{{ cli.brokerName }}</td>
        <td width='15%' class='rowTitle'>{{ cli.accountName }}</td>
        <td width='15%' class='rowTitle'>{{ cli.instrumentName }}</td>
        <td width='10%' class='rowTitle center' :class='cli.orderSide === "B"  ? "positive" : "negative"'>{{ cli.orderSide }}</td>
        <td width='10%' class='rowTitle center' >{{ cli.orderType }}</td>
        <td width='15%' class='rowData' :class='cli.rate >= 0  ? "positive" : "negative"'>{{ cli.rate }}</td>
        <td width='15%' class='rowData' :class='cli.workingAmount >= 0  ? "positive" : "negative"'>{{ cli.workingAmount | formatAmount }}</td>
      </tr>
    </table>
    -->

     <el-table
      class='riskTable'
      :cell-class-name = "() => 'lu-click'"
      :data="data"
      :height="parentPanelHeight"
      fit
      style="width: 100%;"
      :row-class-name="tableRowClassName"
      @row-dblclick='row => getDetail(row.brokerName,row.accountNumber,row.accountName)'
    >
      <el-table-column :label="$t('Env')" sortable prop='brokerName' align="left" />
      <el-table-column :label="$t('Client')" sortable prop='accountName' align="left" min-width='200' />
      <el-table-column :label="$t('Account')" sortable prop='accountNumber' align="left" />
      <el-table-column :label="$t('Instrument')" sortable prop='instrumentName' align="left" min-width='100' />
      <el-table-column :label="$t('Order Side')" sortable align="center" width='120'>
        <template slot-scope="scope">
          <div style='text-align: center'  :class='scope.row.orderSide === "B"  ? "positive" : "negative"'>{{ scope.row.orderSide }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('Order Type')" sortable align="center" prop="orderType" width='120'/>
      <el-table-column :label="$t('Price')" sortable :sort-method='(a,b) => sortFloat(a,b,"rate")' align="center" >
        <template slot-scope="scope">
          <div style='text-align: right' :class='scope.row.rate >= 0  ? "positive" : "negative"'>{{ scope.row.rate }}</div>
        </template>
      </el-table-column>

      <el-table-column :label="$t('Working Amt')" sortable :sort-method='(a,b) => sortFloat(a,b,"workingAmount")' align="center" >
        <template slot-scope="scope">
          <div style='text-align: right' :class='scope.row.workingAmount >= 0  ? "positive" : "negative"'>{{ scope.row.workingAmount | formatAmount }}</div>
        </template>
      </el-table-column>

    </el-table>
  </div>
</template>

<script>
// import { LuHbox, LuVbox, LuItem } from 'lusis-ui'
import utils from '@/utils/formatNumber'
import monitoringMixin from './mixins'

export default {
  name: 'OrderArray',
  // components: { LuHbox, LuVbox, LuItem },
  props: [ 'data', 'parentPanel', 'panel' ],
  mixins: [ monitoringMixin ],
  filters: {
    formatAmount: function (value) {
      return utils.formatAmount(value, 2, 3)
    },
    formatRate: function (value, prec) {
      value = value || 0
      let idx = ('' + value).indexOf('.')
      if (idx !== -1) prec = value.length - idx - 1
      return utils.formatNumber(value, prec)
    },
    formatPercent: function (value) {
      return value + ' %'
    }
  },
  methods: {
    getDetail: function (brokerName, accountNumber, label) {
      let params = [
        {'paramName': 'origin', 'paramValue': this.panel.id},
        {'paramName': 'platform', 'paramValue': brokerName},
        {'paramName': 'accountNumber', 'paramValue': accountNumber},
        {'paramName': 'account', 'paramValue': label}
      ]
      this.$emit('getDetail', {title: 'this.panel.options.title', type: 'account', value: label, params: params, show: true})
    }
  }
}
</script>

<style scoped>
</style>